
import { useSelector } from "react-redux"
import { defaultDateFormatFromISO } from "../../../utils/DefaultDateFormats"
import style from "./style.module.css"
import TeacherIcon from "../../../assets/teacher-icon.svg"
import { useEffect, useState } from "react"
import axios from "axios"
import { toast } from "react-toastify"
import DefaultLoading from "../../../components/DefaultLoading"
const ClassInformation = () => {
    const classData = useSelector(store => store.AuthReducer.studentData.c_id)
    const [isStudentsLoading, setIsStudentLoading] = useState(true)
    const [students, setStudents] = useState([])

    useEffect(() => {
        axios.get(`/getClassStudents/${classData._id}`)
            .then(res => {
                console.log(res)
                setStudents(res.data.data)
                setIsStudentLoading(false)
            })
            .catch(err => {
                console.log(err)
                console.log(err.response)
                toast.error("Something went wrong")
                setIsStudentLoading(false)
            })
    }, [classData._id])
    return (
        <div className={style.mainDiv}>
            <h2 className={style.screenHeading}>Class Information</h2>
            <div className={style.classInfoMainWrapper}>
                <div className={style.classInfo}>
                    <h5 className={style.classInfoHeading}>Class Information</h5>
                    <p className={style.classInfoTag}><span className={style.classInfoTagHeading}>Class Name:</span>{classData.name}</p>
                    <p className={style.classInfoTag}><span className={style.classInfoTagHeading}>Start Date:</span>{defaultDateFormatFromISO(classData.startDate)}</p>
                    <p className={style.classInfoTag}><span className={style.classInfoTagHeading}>End Date:</span>{defaultDateFormatFromISO(classData.endDate)}</p>
                    <p className={style.classInfoTag}><span className={style.classInfoTagHeading}>Total Students:</span>{classData.students}</p>
                    <p className={style.classInfoTag}><span className={style.classInfoTagHeading}>Total Teachers:</span>{classData.subTeachers.length}</p>
                </div>
                <div className={style.classInfo}>
                    <h5 className={style.classInfoHeading}>Class Teacher</h5>
                    <p className={style.classInfoTag}><span className={style.classInfoTagHeading}>Name:</span>{classData.classTeacher.name}</p>
                    <p className={style.classInfoTag}><span className={style.classInfoTagHeading}>Subject:</span>{classData.classTeacherSubject}</p>

                </div>

            </div>
            <div className={style.subjectTeachersDivWrapper}>
                <h1 className={style.classInfoHeading}>Subject Teachers</h1>
                <div className={style.subTeachersWrapper}>
                    {
                        classData.subTeachers.map((teacher, index) => {
                            return (
                                <div key={index} className={style.subTeacher}>
                                    <img className={style.teacherIcon} src={TeacherIcon} alt="..." />
                                    <p className={style.teacherName}>{teacher.t_id.name}</p>
                                    <p className={style.teacherSubject}>{teacher.subject}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className={style.studentsDivWrapper}>
                <h1 className={style.classInfoHeading}>Students</h1>
                {
                    isStudentsLoading
                        ?
                        <DefaultLoading />
                        :

                        <div className={style.studentsWrapper}>
                            {
                                students.map((student, index) => {
                                    return (
                                        <div key={index} className={style.student}>
                                            <i className={"fa-solid fa-user-ninja " + style.studentIcon}></i>
                                            <p className={style.studentName}>{student.name}</p>
                                            <p className={style.studentEmail}>{student.email}</p>
                                        </div>
                                    )
                                })
                            }

                        </div>
                }
            </div>

        </div>
    )
}

export default ClassInformation